import React from 'react'
import BarChartWidget from '@components/ResultWidget/BarChartWidget/BarChartWidget'
import { DsmpChart } from '@components/Survey/Dsmp/DsmpChart'
import { PredictionResults } from '@models/Prediction/Prediction'
import { isDsmpPrediction } from '@utils/categoryFlow'
import type { ResultVariant } from '@utils/categoryFlow'

function isPredictionResults(value: unknown): value is PredictionResults {
  return typeof value === 'object' && value !== null && 'prediction' in value
}

/** Full results chart (modal) — BarChartWidget / DsmpChart as on the results page. */
export function ResultsChartView({
  snapshot,
  resultVariant,
  dsmpQ1,
  dsmpQ2,
}: {
  snapshot: PredictionResults
  resultVariant?: ResultVariant
  dsmpQ1?: number
  dsmpQ2?: number
}) {
  if (!isPredictionResults(snapshot)) {
    return null
  }
  if (isDsmpPrediction(snapshot.prediction)) {
    const score = snapshot.prediction.dsmpScore ?? snapshot.prediction.dsmp_score
    return (
      <DsmpChart
        dsmpQ1={resultVariant === 'intermediate' ? score ?? dsmpQ1 : dsmpQ1 ?? score}
        dsmpQ2={resultVariant === 'final' ? dsmpQ2 ?? score : undefined}
      />
    )
  }
  return <BarChartWidget predictionResults={snapshot} />
}

export { isPredictionResults }
